module.exports = __webpack_public_path__ + "img/havoc.9b168e49.jpg";